import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f18e5eda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-location" }
const _hoisted_2 = { class: "sidebar-menu-item__namespace-icon-wrap" }
const _hoisted_3 = { class: "menu__title_hidden" }
const _hoisted_4 = { class: "menu__title_hidden" }

import { ref, computed, onMounted, watch } from "vue";
import { TirPmDropdown, TirPmDropdownSizeEnum, TirPmIconView, TirPmSvg } from "tir-components";
import { GroupModel, NamespaceModel, QueueTasksModel } from "../sidebar/models";
import { PropType } from "vue";
import { ChevronDownIcon, FolderIcon, ListBulletIcon } from "tir-style-system/icons/outline";

import { ChevronUpIcon } from "tir-style-system/icons/solid";
// Определение пропсов компонента

export default /*#__PURE__*/_defineComponent({
  __name: 'task-location',
  props: {
  items: {
    type: Array as PropType<(NamespaceModel | GroupModel | QueueTasksModel)[]>,
    default: [],
  },

  /** Элемент меню */
  item: {
    type: Object as PropType<NamespaceModel | GroupModel | QueueTasksModel>,
    required: true,
  },
  /** Открыт ли sidebar */
  isSidebarOpen: {
    type: Boolean,
  },
  /** Открыт ли sidebar */
  isNamespaceItemHide: {
    type: Boolean,
    default: false,
  },
  /** Уровень вложенности меню */
  level: {
    type: Number,
    default: 0,
  },
},
  emits: ["onChange"],
  setup(__props, { emit: emits }) {

const props = __props;

// Импорты из Vue 3 Composition API

const visibleIdx = ref<Array<string>>([]);

/**Элемент рабочей области */
const namespaceItem = computed(() => (props.item.isNamespace() ? props.item : undefined));
/**Элемент группы */
const groupItem = computed(() => (props.item.isGroup() ? props.item : undefined));
/**Элемент очереди задач */
const queueItem = computed(() => (props.item.isQueue() ? props.item : undefined));
// // Определение эмиттеров событий компонента


const isShow = ref(false);
function calculatePadding(item) {
  let padding = 1;
  let currentItem = item;

  while (currentItem?.ParentGroupId) {
    padding += 1;
    currentItem = props.items.find((group) => group.Id === currentItem.ParentGroupId);
  }
  console.log(padding);
  return padding;
}
/**Выбор проекта */
function selectItem(project: NamespaceModel | GroupModel| QueueTasksModel) {
  // getProjects();
  isShow.value = !isShow.value;
  emits("onChange", project, isShow.value);
}

function truncateName(name: string, length: number = 28) {
  if (!name) return "";
  return name.length > length ? name.substring(0, length) + "..." : name;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (namespaceItem.value && !__props.isNamespaceItemHide)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: {"display":"flex","align-items":"center","width":"100%"},
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (selectItem(namespaceItem.value)), ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(TirPmSvg), {
              url: namespaceItem.value.IconUrl,
              class: "sidebar-menu-item__namespace-icon",
              color: namespaceItem.value.Color
            }, null, 8, ["url", "color"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["menu__title_hidden", { menu__title_visible: true }])
          }, _toDisplayString(truncateName(namespaceItem.value.Name)), 1),
          ((namespaceItem.value.QueueTasks.length > 0 || namespaceItem.value.Groups.length > 0) && !isShow.value)
            ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                key: 0,
                class: _normalizeClass(["choose-project-dropdown_target_arrow", { open: false }])
              }))
            : _createCommentVNode("", true),
          ((namespaceItem.value.QueueTasks.length > 0 || namespaceItem.value.Groups.length > 0) && isShow.value)
            ? (_openBlock(), _createBlock(_unref(ChevronUpIcon), {
                key: 1,
                class: _normalizeClass(["choose-project-dropdown_target_arrow", { open: false }])
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (groupItem.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle({
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          paddingLeft: calculatePadding(groupItem.value) + 'rem',
        }),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (selectItem(groupItem.value)), ["stop"]))
        }, [
          _createVNode(_unref(FolderIcon), {
            class: "menu__icon",
            style: {"width":"1rem","margin-right":"1rem"}
          }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(truncateName(groupItem.value?.Name)), 1),
          ((groupItem.value.QueueTasks.length > 0 || groupItem.value.Groups.length > 0) && !isShow.value)
            ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                key: 0,
                class: _normalizeClass(["choose-project-dropdown_target_arrow", { open: false }])
              }))
            : _createCommentVNode("", true),
          ((groupItem.value.QueueTasks.length > 0 || groupItem.value.Groups.length > 0) && isShow.value)
            ? (_openBlock(), _createBlock(_unref(ChevronUpIcon), {
                key: 1,
                class: _normalizeClass(["choose-project-dropdown_target_arrow", { open: false }])
              }))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    (queueItem.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          style: _normalizeStyle({
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          paddingLeft: calculatePadding(queueItem.value) + 'rem',
        }),
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (selectItem(queueItem.value)), ["stop"]))
        }, [
          _createVNode(_unref(ListBulletIcon), {
            class: "menu__icon",
            style: {"width":"1rem","margin-right":"1rem"}
          }),
          _createElementVNode("div", _hoisted_4, _toDisplayString(truncateName(queueItem.value?.Name)), 1)
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})